module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAAXNSR0IB2cksfwAAAB5QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtyhvagAAAAp0Uk5TADCPEJD/z9DS02gl7V4AAAB5SURBVHicRdDBDYAgEATAS+jA2IAd8IK3Dzogim9jBcYSKIF+PY69g98yCbuBFk84bqN0awiZ4gFyz0vuA4WTb0EdSEkANAAEEFIQMmAqVYGpXX6GWmYIV7OF/JQt7B22UDqUpAOE8kEoF7JVnWxVp2SrYqZ1ftX+A6zhIiNLlsnMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-view--exit@2x.png
// module id = 796
// module chunks = 0